module.exports = __webpack_public_path__ + "static/img/good_selected.c325d8f4.png";